import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import DataMaterialTable from "../../../components/ui/dataTable/dataMaterialTable";
import { useTranslation } from "react-i18next";
import { ActionBtn } from "../../../components/ui/dataTable/components/actionBtn";
import { ActionDetail } from "../../../components/ui/dataTable/components/actionDetail";
import {
  notifyDefault,
  notifySuccess,
} from "../../../components/ui/popup/toastPopup";
import { BoxImageBlank } from "../../../components/ui/boxImage/boxImageBlank";
import Swal from "sweetalert2";
import { MomentConvert } from "../../../components/ui/moment/momentConvert";
import { BoxImageByKey } from "../../../components/ui/boxImage/boxImageByKey";
import BreadcrumbsTitle from "../../../components/ui/breadcrumbsTitle";
import { getAllSelfPickupAdmin } from "../../../service/selfPickUp/selfPickupAdmin/getAllSelfPickupAdmin";
import { updateSelfPickupAdmin } from "../../../service/selfPickUp/selfPickupAdmin/updateSelfPickupAdmin";
import { getSelfPickupAdmin } from "../../../service/selfPickUp/selfPickupAdmin/getSelfPickupAdmin.js";
function SelfPickupAdmin() {
  const [rows, setRows] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [columns, setColumns] = useState([]);
  const { t } = useTranslation();

  const onUpdateConfirm = async (item, e) => {
    let checked = e.target.checked;
    if (checked) {
      onUpdateStatus(item, checked);
    } else {
      Swal.fire({
        title: t("notification_confirm_change_status"),
        text: t(
          "notification_changing_the_status_will_affect_the_branch_settings"
        ),
        icon: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          onUpdateStatus(item, checked);
          //sss
        }
      });
    }
  };
  const onUpdateStatus = async (item, checked) => {
    setRows((prevRows) => {
      const dataNews = [...prevRows];
      dataNews[item.index].status = checked;
      return dataNews;
    });
    let dataUser = await getSelfPickupAdmin(item.original.id);
    if (!dataUser) {
      setRows((prevRows) => {
        const dataNews = [...prevRows];
        dataNews[item.index].status = !checked;
        return dataNews;
      });
      return;
    }
    let dataAPI = {
      id: dataUser.id,
      position: dataUser.positionUser,
      pin: dataUser.pin,
      profile_img: dataUser.profile_img,
      nat_id: dataUser.nat_id,
      tel: dataUser.tel,
      email: dataUser.email,
      status: checked,
      self_pickup_admin_lang: {
        firstname: dataUser.self_pickup_admin_lang?.firstname,
        lastname: dataUser.self_pickup_admin_lang?.lastName,
        language_code: String(localStorage.getItem("language_form")),
      },
    };
    let statusAPI = await updateSelfPickupAdmin(dataAPI);
    if (statusAPI === "OK") {
      if (checked) {
        notifySuccess({ title: t("toast_active") });
      } else {
        notifyDefault({ title: t("toast_in_active") });
      }
      fetchData();
    }
  };
  const fetchData = async () => {
    let dataColumns = [
      {
        accessorKey: "action",
        enableSorting: false,
        header: "Action",
        size: 100,
        sortable: false,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", gap: 2 }}>
            <ActionDetail
              params={row}
              detailPath={"/self-pickup-admin/detail/"}
            />
          </Box>
        ),
      },
      {
        accessorKey: "profile_img",
        size: 100,
        enableSorting: false,
        header: t("global_image"),
        Cell: ({ row }) => (
          <>
            {row.original.profile_img ? (
              <BoxImageByKey
                imageKey={row.original.profile_img}
                width={"50px"}
                height={"50px"}
                type="table"
              />
            ) : (
              <BoxImageBlank width={50} height={50} />
            )}
          </>
        ),
      },
      {
        accessorKey: "position",
        header: t("staff_pos_position"),
        size: 100,
      },
      {
        accessorKey: "updated_at",
        header: t("global_updated_at"),
        size: 100,
        Cell: ({ cell }) => (
          <Typography sx={{fontSize:"14px"}}>{MomentConvert(cell.getValue())}</Typography>
        ),
      },
      {
        accessorKey: "email",
        header: t("global_email"),
        size: 100,
      },
      {
        accessorKey: "status",
        enableSorting: false,
        header: t("global_status"),
        size: 100,
        Cell: ({ row }) => (
          <ActionBtn
            row={row}
            status={row.original.status}
            onUpdateStatus={onUpdateConfirm}
          />
        ),
      },
    ];

    let dataAPI = await getAllSelfPickupAdmin();
    if (dataAPI) {
      dataAPI.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
      setRows(dataAPI);
    }
    setColumns(dataColumns);

    setIsLoadingData(false);
  };

  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <BreadcrumbsTitle
        props={{
          title: t("self_pickup_admin"),
        }}
      />
      <DataMaterialTable statusViewMode={true}
        rows={rows}
        isLoadingData={isLoadingData}
        columns={columns}
        detailPath={"/online-admin/detail/"}
        createButton={t("self_pickup_admin")}
      />
    </Box>
  );
}

export default SelfPickupAdmin;
